import React, { useEffect, useState } from "react";
import {
  useGetTeacherById,
  useUpdateTeacher,
} from "../../hooks/teacherHooks/teacher.hooks";
import { getValue } from "../../utils/object.utils";
import { TeachersForm } from "./TeachersForm";
import { JobType } from "../../Constants/Enums/teachers.enum";
import { Profile } from "../Profile/Profile";
import { Card } from "../card";
import { useDispatch } from "react-redux";
import {
  setErrorMessage,
  setSuccessMessage,
} from "../../Redux/Slices/alert.slice";
import { parseApiError } from "../../Helper/apiError.helper";

interface Props {
  teacherId: number;
}
export const TeacherDetails = ({ teacherId }: Props) => {
  const dispatch = useDispatch();

  const { isLoading: isTeacherLoading, data: teacherData } = useGetTeacherById({
    teacherId,
  });

  const { isLoading: isUpdatingTeacher, mutate: updateTeacher } =
    useUpdateTeacher({ teacherId });

  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [address, setAddress] = useState("");
  const [gender, setGender] = useState("");
  const [classId, setClassId] = useState<number | null>(null);
  const [schoolBranchId, setSchoolBranchId] = useState<number | null>(null);
  const [schoolBlockId, setSchoolBlockId] = useState<number | null>(null);
  const [subjects, setSubjects] = useState([]);
  const [jobType, setJobType] = useState<JobType>(JobType.FULLTIME);
  const [baseSalary, setBaseSalary] = useState("");
  // const [password, setPassword] = useState("");

  const initializeData = () => {
    const firstName = getValue(teacherData, "user.first_name");
    const middleName = getValue(teacherData, "user.middle_name");
    const lastName = getValue(teacherData, "user.last_name");
    const email = getValue(teacherData, "user.email");
    const mobile = getValue(teacherData, "user.mobile");
    const address = getValue(teacherData, "user.address");
    const gender = getValue(teacherData, "user.gender");
    const classId = getValue(teacherData, "class.id");
    const schoolBlockId = getValue(teacherData, "school_block.id");
    const schoolBranchId = getValue(teacherData, "school_block.id");
    const subjects = getValue(teacherData, "subjects", []).map(
      (subject: any) => ({
        value: getValue(subject, "id"),
        category: getValue(subject, "type"),
        text: getValue(subject, "name"),
      })
    );
    const jobType = getValue(teacherData, "job_type", JobType.FULLTIME);
    const baseSalary = getValue(teacherData, "base_salary");

    setFirstName(firstName);
    setMiddleName(middleName);
    setLastName(lastName);
    setEmail(email);
    setMobile(mobile);
    setAddress(address);
    setGender(gender);
    setClassId(classId);
    setSchoolBlockId(schoolBlockId);
    setSchoolBranchId(schoolBranchId);
    setSubjects(subjects);
    setJobType(jobType);
    setBaseSalary(baseSalary);
  };

  useEffect(() => {
    if (isTeacherLoading) return;
    initializeData();
  }, [isTeacherLoading]);

  const onTeacherUpdate = () => {
    updateTeacher(
      {
        firstName,
        middleName,
        lastName,
        email,
        mobile,
        address,
        baseSalary,
        jobType,
        schoolBranchId,
        schoolBlockId,
        subjects,
        classId,
      },
      {
        onSuccess: () => {
          dispatch(
            setSuccessMessage("Teacher detail has been updated successfully.")
          );
        },
        onError: (error: any) => {
          const parsedError = parseApiError(error);
          dispatch(setErrorMessage(parsedError));
        },
      }
    );
  };

  if (isTeacherLoading || !teacherData) return <></>;

  return (
    <Card>
      <Profile>
        <TeachersForm
          firstName={firstName}
          middleName={middleName}
          lastName={lastName}
          email={email}
          password={""}
          mobile={mobile}
          address={address}
          gender={gender}
          classId={classId as number}
          schoolBlockId={schoolBlockId as number}
          schoolBranchId={schoolBranchId as number}
          subjects={subjects as []}
          jobType={jobType}
          baseSalary={baseSalary as string | null}
          onSetFirstName={(firstName: string) => {
            setFirstName(firstName);
          }}
          onSetMiddleName={(middleName: string) => {
            setMiddleName(middleName);
          }}
          onSetLastName={(lastName: string) => {
            setLastName(lastName);
          }}
          onSetEmail={(email: string) => {
            setEmail(email);
          }}
          onSetPassword={(password: string) => {
            // setPassword(password);
          }}
          onSetMobile={(mobile: string) => {
            setMobile(mobile);
          }}
          onSetAddress={(address: string) => {
            setAddress(address);
          }}
          onSetGender={(gender: string) => {
            setGender(gender);
          }}
          onSetJobType={(jobType: JobType) => {
            setJobType(jobType);
          }}
          onSetBaseSalary={(baseSalary: string | number) => {
            setBaseSalary(baseSalary as string);
          }}
          onSetSubjects={(subjects: []) => {
            setSubjects(subjects);
          }}
          onSetSchoolBlockId={(blockId: number) => {
            setSchoolBlockId(blockId);
          }}
          onSetSchoolBranchId={(branchId: number) => {
            setSchoolBranchId(branchId);
          }}
          onSetClassId={(classId: number) => {
            setClassId(classId);
          }}
          onReset={() => {
            //   reset();
          }}
          onSubmit={() => {
            onTeacherUpdate();
          }}
          isSubmitting={isUpdatingTeacher}
          submitText="Update"
          isUpdating={true}
        />
      </Profile>
    </Card>
  );
};
